exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".demo-chip-list {\n  width: 100%; }\n\nh6 {\n  font-size: 0.8em !important;\n  margin-bottom: 0;\n  color: #518c85;\n  font-weight: bold; }\n\nlabel {\n  font-size: 0.85em !important; }\n\n.mat-chip:not(.mat-basic-chip) {\n  padding: 4px 5px; }\n\n.row {\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 0px; }\n\n.col-md-3 {\n  width: 20%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/Natalia.Morales/IdeaProjects/datagate/administrator/frontend/src/main/webapp/src/app/layout/content/seguridad/emisor/cmp-conf-series/css/cmp-conf-series.component.scss
// module id = ../../../../../src/app/layout/content/seguridad/emisor/cmp-conf-series/css/cmp-conf-series.component.scss
// module chunks = main